import { Injectable } from '@angular/core';
import { MxLoggerService } from '@motivforce/mx-library-angular';
import { IsLoadingService } from '@service-work/is-loading';
import { BehaviorSubject } from 'rxjs';

import { CertificationRestService } from '../api/rest/certification-rest.service';
import { Certificate } from '../model/course/certificate';
import { CertificationData } from '../model/course/certification-data';

@Injectable({
  providedIn: 'root',
})
export class CertificationStoreService {
  private readonly _currentCertificates = new BehaviorSubject<Certificate[] | null>(null);
  readonly currentCertificates$ = this._currentCertificates.asObservable();

  private readonly _currentCertificationData = new BehaviorSubject<CertificationData | null>(null);
  readonly currentCertificationData$ = this._currentCertificationData.asObservable();

  constructor(
    private certificationRest: CertificationRestService,
    private isLoadingService: IsLoadingService,
    private mxLogger: MxLoggerService
  ) {}

  get currentCertificates(): Certificate[] | null {
    return this._currentCertificates.getValue();
  }

  get currentCertificationData(): CertificationData | null {
    return this._currentCertificationData.getValue();
  }

  loginClaim(loginId: string): Promise<boolean> {
    return new Promise((resolve) => {
      this.isLoadingService.add(
        this.certificationRest.loginClaim(loginId).subscribe(
          () => resolve(true),
          () => resolve(false)
        )
      );
    });
  }

  loginClaimCheck(): Promise<boolean> {
    return new Promise((resolve) => {
      this.isLoadingService.add(
        this.certificationRest.loginClaimCheck().subscribe(
          () => resolve(true),
          () => resolve(false)
        )
      );
    });
  }

  getCertificates(): void {
    if (!this.currentCertificates) {
      this.isLoadingService.add(
        this.certificationRest.getCertificates().subscribe((certificates: Certificate[]) => {
          this._currentCertificates.next(certificates);
        })
      );
    }
  }

  validateClaim(data: CertificationData): void {
    this.isLoadingService.add(
      this.certificationRest.validateClaim(data).subscribe((res) => {
        this._currentCertificationData.next(res);
      })
    );
  }

  syncCertificates(): void {
    this.certificationRest.syncCertificates().subscribe({
      error: (error) => this.mxLogger.warn('SyncCourses fire and forget method failed.', error),
    });
  }
}
